<template>
  <div class="mission-sns-button-parts">
    <h3 class="mission-sns-button-parts__title">
      {{ $tc('common.sns.post') }}
    </h3>
    <ul class="mission-sns-button-parts__buttons">
      <li class="mission-sns-button-parts__buttons-item" ref="buttonX">
        <button
          class="mission-sns-button-parts__button"
          :class="{
            'mission-sns-button-parts__button--active': postX,
          }"
          @click="onChangePostX"
        >
          <label for="comment" class="mission-sns-button-parts__button-label"
            ><mission-x-icon
          /></label>
        </button>
      </li>
      <li v-if="false" class="mission-sns-button-parts__buttons-item" ref="buttonInstagram">
        <button
          class="mission-sns-button-parts__button"
          :class="{
            'mission-sns-button-parts__button--active': postInstagram,
          }"
          @click="onChangePostInstagram"
        >
          <label for="comment" class="mission-sns-button-parts__button-label"
            ><mission-instagram-icon
          /></label>
        </button>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import MissionInstagramIcon from '@/components/MissionPage/MissionRankingPane/parts/icons/MissionInstagramIcon.vue'
import MissionXIcon from '@/components/MissionPage/MissionRankingPane/parts/icons/MissionXIcon.vue'

export default defineComponent({
  name: 'MissionSnsButtonParts',
  components: {
    MissionXIcon,
    MissionInstagramIcon,
  },
  props: {
    /**
     * Xにランキングを投稿するかどうか
     */
    postX: {
      type: Boolean,
      default: false,
    },
    /**
     * Instagramにランキングを投稿するかどうか
     */
    postInstagram: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onChangePostX() {
      this.$emit('onChangePostX', !this.postX)
    },
    onChangePostInstagram() {
      this.$emit('onChangePostInstagram', !this.postInstagram)
    },
  },
})
</script>

<style scoped lang="scss">
.mission-sns-button-parts {
  display: flex;
  gap: 28px;
  flex-wrap: wrap;
  align-items: center;

  &__title {
    font-size: 13px;
    font-weight: 700;
    color: $white;
    letter-spacing: 0.04em;
    white-space: nowrap;
  }

  &__buttons {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center;

    &-item {
      position: relative;
    }
  }

  &__button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    color: $white;
    background-color: rgba(#fff, 0.2);
    border-radius: 6px;

    &-label {
      position: relative;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }

    &--active {
      position: relative;
      background-color: transparent;

      &::after {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 36px;
        height: 36px;
        content: '';
        border: 2px solid $green-light;
        border-radius: 6px;
        transform: translate(-50%, -50%);
      }
    }
  }
}
</style>
